<template>
  <div>
    Unimplemented yet.
  </div>
</template>

<script>
export default {
  name:"CustomTimepicker",
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// client/components/Forms/Elements/Timepicker.vue